/* 🤖 this file was generated by svg-to-ts */
export const siriusCaretUp: {
  name: 'caret_up';
  data: string;
} = {
  name: 'caret_up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.47 6.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 8.56l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z" fill="currentColor"/></svg>`
};
